// extracted by mini-css-extract-plugin
export default {"transition-exit":"FLU3xF","transition-exit-active":"ktEyM7"};